import React from "react";
import PrimaryButton from "./PrimaryButton";
import { MessageSquare } from "lucide-react";

export default function TalkToSpecialistButton() {
  return (
    <PrimaryButton
      icon={MessageSquare}
      onClick={() =>
        window.open(
          "https://api.whatsapp.com/send/?phone=5521997688078&text&type=phone_number&app_absent=0",
          "_blank"
        )
      }
    >
      Fale com um especialista
    </PrimaryButton>
  );
}
